var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubePurple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5920_14429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8 17.1429L21.104 12L12.8 6.85714V17.1429ZM31.296 3.72C31.504 4.52571 31.648 5.60571 31.744 6.97714C31.856 8.34857 31.904 9.53143 31.904 10.56L32 12C32 15.7543 31.744 18.5143 31.296 20.28C30.896 21.8229 29.968 22.8171 28.528 23.2457C27.776 23.4686 26.4 23.6229 24.288 23.7257C22.208 23.8457 20.304 23.8971 18.544 23.8971L16 24C9.296 24 5.12 23.7257 3.472 23.2457C2.032 22.8171 1.104 21.8229 0.704 20.28C0.496 19.4743 0.352 18.3943 0.256 17.0229C0.144 15.6514 0.0959999 14.4686 0.0959999 13.44L0 12C0 8.24571 0.256 5.48571 0.704 3.72C1.104 2.17714 2.032 1.18286 3.472 0.754286C4.224 0.531429 5.6 0.377143 7.712 0.274285C9.792 0.154285 11.696 0.102857 13.456 0.102857L16 0C22.704 0 26.88 0.274286 28.528 0.754286C29.968 1.18286 30.896 2.17714 31.296 3.72V3.72Z",
    fill: "#8601C9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5920_14429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubePurple);
export default __webpack_public_path__ + "static/media/youtubePurple.a2ef258b.svg";
export { ForwardRef as ReactComponent };